const footerLinks = [
  {
    title: '热门板块',
    links: [
      { label: '吃瓜热搜榜', href: '#ranking' },
      { label: '最新爆料动态', href: '#updates' },
      { label: '话题广场', href: '#topics' },
      { label: '焦点专题', href: '#carousel' },
      { label: '视频专区', href: '#media' },
    ],
  },
  {
    title: '快捷入口',
    links: [
      { label: '主题索引', href: '#index' },
      { label: '热门图文', href: '#cards' },
      { label: '吃瓜热评', href: '#comments' },
      { label: 'APP下载', href: '#app' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '平台介绍', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '特色优势', href: '#features' },
    ],
  },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-radar-line text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                51吃瓜网
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60 mb-4 max-w-sm">
              51吃瓜网官网——吃瓜爆料第一站。聚焦51吃瓜爆料与51吃瓜黑料，
              覆盖明星网红八卦最新动态、全网猛料汇总及热点人物内幕。
              每日实时更新51吃瓜网今日吃瓜资源，不吃哑巴瓜，只吃新鲜瓜。
            </p>
            <div className="flex gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/60 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-50/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/60 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-50/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500/60 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-background-50/70"></i>
              </a>
            </div>
          </div>

          {/* Link groups */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-background-50/10 pt-8 mb-8">
          <h4 className="font-heading text-sm font-semibold text-background-50/50 mb-3">
            合作伙伴
          </h4>
          <p className="text-xs text-background-50/40">
            期待与更多优质合作伙伴携手同行，共创吃瓜新生态
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; 2026 51吃瓜网官网. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex gap-4">
            <a href="#hero" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#hero" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}